// extracted by mini-css-extract-plugin
module.exports = {"productList__container":"styles_productList__container__dFqvb"};